
<template>
      <div class="clan">
        <div class="clanbox"> 
            <div class="clan-con">
                <p>
                    请先加入战队，<br>
                    再互赠卡片哦！ 
                </p>
                <a data-stat="前往战队" class="zhand" href="//www.ule.com/event/2018/0816/dist/index.html#/">立即前往</a>
            </div>
            <a data-stat="关闭卡片弹层" class="shouxia" @click="hideclan(4)" href="javascript:void(0);"></a>
        </div>
    </div>
</template>

<script>
export default {
  props:['recordif'],
  data () {
      return {
      
      }
    },
    created(){
      var m=this;
    }, 
    methods:{
        hideclan(nu){
            this.$parent.shouxiaokapicha(nu);
        }
          
    } 
}
</script>

<style scoped>
.clan{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left:0;
    z-index: 9999; 
    background-color: rgba(0,0,0,.7);
}
.clan .clanbox{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 6.42rem;
    height: 4.6rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/bg7.png) no-repeat center;
    background-size: 100% 100%;
}
.clan-con{
    width: 100%;
    height: 4.6rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/bg7.png) no-repeat center;
    background-size: 100% 100%;
    padding-top: 1.84rem;
    box-sizing: border-box;
}
.shouxia{
    display: block;
    margin: 0 auto;
    background: url(//i1.ulecdn.com/i/event/2018/0511/tencele/tan5.png) no-repeat center;
    background-size: 100% 100%;
    width: .86rem;
    height: .86rem;
    margin-top: .26rem;
}
p{
    display: block;
    color: #FFFFECB0;
    font-size: .34rem;
    line-height: 0.48rem;
    text-align: center;
}
.zhand{
    display: block;
    margin: 0 auto;
    background: url(//www.ule.com/app/yxd/event/2019/0730/nianhj/images/jika/an15.png) no-repeat center;
    background-size: 100% 100%;
    width: 3.48rem;
    height: .76rem;
    color: #a75d18;
    line-height: 0.76rem;
    text-align: center;
    font-size: .3rem;
    margin-top: .6rem;
}
</style>



// WEBPACK FOOTER //
// src/components/commont/clan.vue